import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type TrackOrderQueryVariables = Types.Exact<{
  orderId: Types.Scalars['Int'];
}>;


export type TrackOrderQuery = { __typename?: 'query_root', customer?: Types.Maybe<{ __typename?: 'CustomerMetadata', id: number, firstName?: Types.Maybe<string>, lastName?: Types.Maybe<string>, email?: Types.Maybe<string>, phone?: Types.Maybe<string> }>, order?: Types.Maybe<(
    { __typename?: 'orders' }
    & TrackOrderFragment
  )> };

export type TrackOrderFragment = { __typename?: 'orders', id: number, code: string, orderItems: Array<{ __typename?: 'order_items', id: number, buyingPriceInCents: number, taxAmountInCents?: Types.Maybe<number>, item: { __typename?: 'items', id: number, sku: string, name: string, properties?: Types.Maybe<any>, itemType: string } }> };

export const TrackOrderFragmentDoc = gql`
    fragment TrackOrder on orders {
  id
  code
  orderItems: order_items {
    id
    buyingPriceInCents: buying_price_in_cents_excl_tax
    taxAmountInCents: tax_amount_in_cents
    item {
      id
      sku
      name
      properties
      itemType: item_type
    }
  }
}
    `;
export const TrackOrderDocument = gql`
    query trackOrder($orderId: Int!) {
  customer: nest_getCustomerMetadata {
    id
    firstName
    lastName
    email
    phone
  }
  order: orders_by_pk(id: $orderId) {
    ...TrackOrder
  }
}
    ${TrackOrderFragmentDoc}`;
export function useTrackOrderQuery(baseOptions: Apollo.QueryHookOptions<TrackOrderQuery, TrackOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackOrderQuery, TrackOrderQueryVariables>(TrackOrderDocument, options);
      }
export function useTrackOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackOrderQuery, TrackOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackOrderQuery, TrackOrderQueryVariables>(TrackOrderDocument, options);
        }
export type TrackOrderQueryHookResult = ReturnType<typeof useTrackOrderQuery>;
export type TrackOrderLazyQueryHookResult = ReturnType<typeof useTrackOrderLazyQuery>;
export type TrackOrderQueryResult = Apollo.QueryResult<TrackOrderQuery, TrackOrderQueryVariables>;